<div class="modal-body m-3">
  <div class="form-label mt-2">
    <h1 style="font-size: x-large" class="dashboard-sub-heading">
      Subscription Package Creation
    </h1>
  </div>

  <hr />
  <mdb-tabs #tab123>
    <mdb-tab title="SUBSCRIPTION PACKAGE">
      <div
        *ngIf="loading"
        class="text-center position-absolute top-50 start-50"
        style="z-index: 10000"
      >
        <div class="spinner-border" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
      <form
        [ngClass]="loading ? 'blur-background': 'row'"
        class="row mt-4"
        [formGroup]="subscriptionPlanForm"
        novalidate
      >

        <div class="col-md-6 text-start">
          <label for="bankName" class="form-label">Package Name</label>
          <input
            type="text"
            class="form-control"
            id="bankName"
            formControlName="packageName"
            [ngClass]="{
                              'is-invalid':
                                createSubscriptionPackSubmited &&
                                formSubscriptionPlanControl['packageName'].errors
                            }"
          />
          <div
            *ngIf="
                              createSubscriptionPackSubmited &&
                              formSubscriptionPlanControl['packageName'].errors
                            "
            class="invalid-feedback"
          >
            <div
              *ngIf="formSubscriptionPlanControl['packageName'].errors['required']"
            >
              Package name is required
            </div>
          </div>
        </div>
        <div class="col-md-6 text-start">
          <label for="bankName" class="form-label">Package Description</label>
          <input
            type="text"
            class="form-control"
            id="bankName"
            formControlName="packageDescription"
            [ngClass]="{
                              'is-invalid':
                                createSubscriptionPackSubmited &&
                                formSubscriptionPlanControl['packageDescription'].errors
                            }"
          />
          <div
            *ngIf="
                              createSubscriptionPackSubmited &&
                              formSubscriptionPlanControl['packageDescription'].errors
                            "
            class="invalid-feedback"
          >
            <div
              *ngIf="
                                formSubscriptionPlanControl['packageDescription'].errors['required']
                              "
            >
              Package description is required
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6 "></div>
          <div class="col-md-6 mt-3 d-flex justify-content-end"><button
            (click)="createSubscriptionPlan()"
            type="button"
            class="btn btn-primary"
            *ngIf="!exchangeVisible"
          >
            CREATE
          </button>
            <button
              (click)="createSubscriptionPlan()"
              type="button"
              class="btn btn-primary"
              *ngIf="exchangeVisible"
            >
              SAVE
            </button>
          </div>
        </div>
      </form>
    </mdb-tab>

    <mdb-tab title="ASSIIGN EXCHANGES" *ngIf="exchangeVisible || isEditPackage">
      <div class="row">
        <div class="col-3">
          <div class="form-label mt-2">
            <h1
              style="font-size: large"
              class="dashboard-sub-heading d-flex align-items-center"
            >
              Add Exchanges
            </h1>
          </div>
        </div>
      </div>
      <form
        [ngClass]="loading ? 'blur-background': 'row'"
        class="row g-3"
        [formGroup]="exchangeForm"
        novalidate
      >
        <span class="border">
          <div
            *ngIf="loading"
            class="text-center position-absolute top-50 start-50"
            style="z-index: 10000"
          >
    <div class="spinner-border" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
          <div class="row">
            <div class="col-md-4 text-start">
              <label for="bankName" class="form-label">Exchange</label>

              <select
                (change)="getDefaultValuesOfExchange()"
                class="form-select"
                aria-label="Default select example"
                formControlName="exchangeType"
                [ngClass]="{
                    'is-invalid':
                      exchnageAddSubmitted &&
                      formExchangeControl['exchangeType'].errors
                  }"
              >
                <option selected value="">-- Select Exchange --</option>

                <option
                  *ngFor="let exchange of exchanges"
                  [value]="exchange.exchangeCode"
                >
                  {{exchange.exchangeCode}}
                </option>
              </select>

              <div
                *ngIf="
                        exchnageAddSubmitted &&
                        formExchangeControl['exchangeType'].errors
                      "
                class="invalid-feedback"
              >
                <div
                  *ngIf="
                          exchnageAddSubmitted &&
                          formExchangeControl['exchangeType'].errors['required']
                        "
                >
                  Exchange type required
                </div>
              </div>
            </div>
            <div style="display: none" class="col-md-4 text-start">
              <input
                type="text"
                class="form-control"
                id="bankName"
                formControlName="exchangeId"
              />
            </div>

            <div class="col-md-4 text-start">
              <label for="bankName" class="form-label">Feed Level</label>
              <select
                class="form-select"
                aria-label="Default select example"
                formControlName="feedLevel"
                [ngClass]="{
                        'is-invalid':
                          exchnageAddSubmitted &&
                          formExchangeControl['exchangeType'].errors
                      }"
              >
                <option value="">-- Select Feed Level --</option>
                <option value="DELAYED">DELAYED</option>
                <option value="REAL TIME L1">REAL TIME L1</option>
                <option value="REAL TIME L2">REAL TIME L2</option>
              </select>
              <div
                *ngIf="
                        exchnageAddSubmitted &&
                        formExchangeControl['feedLevel'].errors
                      "
                class="invalid-feedback"
              >
                <div
                  *ngIf="
                          exchnageAddSubmitted &&
                          formExchangeControl['feedLevel'].errors['required']
                        "
                >
                  Select Feed Level
                </div>
              </div>
            </div>

            <div class="col-md-4 text-start">
              <label for="brokerInstitution" class="form-label">Currency</label>
              <select
                class="form-select"
                aria-label="Default select example"
                formControlName="exchangeCurrency"
                [ngClass]="{
                        'is-invalid':
                          exchnageAddSubmitted &&
                          formExchangeControl['exchangeCurrency'].errors
                      }"

              >
                <option  value="">-- Select Currency --</option>
                <option *ngFor="let val of currencyList" [value]="val.type">{{val.type}}</option>

              </select>

              <div
                *ngIf="
                        exchnageAddSubmitted &&
                        formExchangeControl['exchangeCurrency'].errors
                      "
                class="invalid-feedback"
              >
                <div
                  *ngIf="
                          exchnageAddSubmitted &&
                          formExchangeControl['exchangeCurrency'].errors[
                            'required'
                          ]
                        "
                >
                  Select currency
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 text-start"></div>

            <div class="col-md-6 text-end mt-2">
              <button
                *ngIf="!isEditExchange"
                (click)="addExchange()"
                type="button"
                class="btn btn-primary m-2"
              >
                ADD EXCHANGE
              </button>
              <button
                *ngIf="isEditExchange"
                (click)="saveExchange()"
                type="button"
                class="btn btn-primary m-2"
              >
                SAVE EXCHANGE
              </button>
            </div>
          </div>
        </span>
      </form>
      <table
        *ngIf=" exchangeList.length != 0 && exchangeVisible"
        class="table align-middle mb-0 bg-white table-sm mt-3"
      >
        <thead class="bg-light">
        <tr>
          <th>Exchange</th>
          <th>Feed Level</th>

          <th>Currency</th>

          <th>Action</th>
        </tr>
        </thead>
        <tbody *ngFor="let exchange of exchangeList">
        <tr>
          <td>
            <p class="fw-normal mb-1">{{ exchange.exchange }}</p>
          </td>
          <td>
            <p class="fw-normal mb-1">{{ exchange.feedLevel }}</p>
          </td>

          <td>
            <p class="fw-normal mb-1">{{ exchange.currency }}</p>
          </td>
          <td>
            <button
              (click)="editExchange(exchange.packageExchangeId)"
              class="btn btn-primary"
            >
              <i class="far fa-edit"></i>
            </button>
          </td>
        </tr>
        </tbody>
      </table>
    </mdb-tab>
  </mdb-tabs>
  <div class="mt-3">

  </div>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="modalRef.close()">
    Close
  </button>

</div>

